/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
import {useSelector} from 'react-redux';
// utils
// material
import TableReportSection from "../../../../../material/tablereportsection/tablereportsection";
// styles
import injectSheet from 'react-jss';
import styles from './toppollandquizreport_style';
import {formatNumber} from "../../../../../utils/charts";


/* ========== ~~~~~~~~~~ TRIVIA ANALYTICS - TOP POLL AND QUIZ REPORT ~~~~~~~~~~ ========== */
const TopPollandQuizReport = injectSheet(styles)((props) => {
    const {data, status} = useSelector((state) => state.triviaAndPolls.topCards);

    const columns = [
        {
            key: 'rank',
            title: 'Rank'
        },
        {
            key: 'triviaQuestions',
            title: 'Trivia question'
        },{
            key: 'responses',
            title: 'Responses',
            format: 'comma'
        },
        {
            key: 'skips',
            title: 'Skips',
            format: 'comma'
        },
        {
            key: 'answers',
            title: 'Answers',
            columnCount: 4
        }
    ];
    const maxAnswersCount = data.reduce((prev, current) => prev > Object.keys(current.answers).length ? prev : Object.keys(current.answers).length, 0);

    // I don't like any of this but for speed right now it's more effective to send listTable formatted column content than it is to update iui
    const formatAnswerList = (answers) => {
        return Object.entries(answers).map((answer) => {
                return formatAnswer(answer[1].value, answer[1].rate)
            });
    }
    const formatAnswer = (answerText, rate) => {
        return <div>
            <div style={{color: '#244eb9', fontSize: 12}}>
                {answerText}
            </div>
            <div style={{color: '#b2c1e6', fontSize: 12}}>
                {formatNumber(rate, 'percent', true)}
            </div>
        </div>;
    }
    const formattedAnswersData = (data) => {
        return data.map(row => {
            return {
                ...row,
                answers: formatAnswerList(row.answers),
                answersList: row.answers
            }
        })
    };

    const handleExportDataTransform = (obj) => obj.map(row => {
        const { answersList, ...others } = row;
        const formattedData = { ...others };
        const answersArr = Object.entries(answersList).map(e => ({ name: e[0], value: e[1].count }));
        for (let i = 0; i < maxAnswersCount && i < answersArr.length; i++) {
            formattedData[`Answer ${i + 1}`] = answersArr[i].name;
            formattedData[`Answer ${i + 1} Count`] = answersArr[i].value;
        }
        return formattedData;
    });

    const exportDataConfig = {
        fileName: 'top_poll_and_quiz_cards',
        excludedColumns: ['answers', ''],
        transpiler: handleExportDataTransform
    };
    const exportAllDataConfig = {
        onClick: props.onExportAllClick
    }
    return (
        <div name={'toppollandquizreport'} klass={`${props.classes.toppollandquizreport}`}>
            <TableReportSection
                title={'Top Poll & Quiz Cards'}
                columns={columns}
                data={formattedAnswersData(data.slice(0, 50))}
                rowsPerPage={20}
                exportData={exportDataConfig}
                exportAll={exportAllDataConfig}
                loading={status === 'pending'}
                type={'standard'}
                tooltipContent={
                    <div className={'tip-content'}>
                        <div className={'tip-title'}>
                            <h4>Top Trivia & Polls Cards</h4>
                        </div>
                        <div className={'tip-desc'}>
                            <p>
                                The table shows the top 50 most popular cards based on the number of responses. The table also includes the answers to the questions with a breakdown, by percentage of total, the response rate for each of the answers.
                            </p>
                        </div>
                    </div>
                }
            />
        </div>
    );
});


/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default TopPollandQuizReport;
